const buildBundleItems = ({ items }) => {
  const bundles = items.reduce((result, item) => {
    const bundleId = item.properties.bundle_id;

    if (bundleId === undefined) return result;

    const currentBundleItems = result[bundleId] || [];

    return { ...result, ...{ [bundleId]: [...currentBundleItems, item] }};
  }, {});

  return Object.keys(bundles).map((bundleId) => {
    const bundleItems = bundles[bundleId];
    const bundleSize = bundleItems.reduce((result, item) => result + item.quantity, 0);

    return ({
      title: `Bundle Pack (${bundleSize})`,
      items: bundleItems,
      size: bundleSize,
      bundle: true,
      id: bundleId,
      imgUrl: 'https://cdn.shopify.com/s/files/1/0257/2733/6499/files/bm-sm-cart-item.jpg?v=1620561004'
    });
  });
};

const buildKitItems = ({ items }) => {
  const kits = items.reduce((result, item) => {
    const kitId = item.properties.kit_id;

    if (kitId === undefined) return result;

    const currentKitItems = result[kitId] || [];

    return { ...result, ...{ [kitId]: [...currentKitItems, item] }};
  }, {});

  return Object.keys(kits).map((kitId) => {
    const kitItems = kits[kitId];
    const kitTitle = kitItems[0].properties.kit_title;
    const kitSize = kitItems.reduce((result, item) => result + item.quantity, 0);

    const { image } = document.querySelector(`script[data-product-title="${kitTitle}"`).dataset;

    return ({
      title: kitTitle,
      items: kitItems,
      size: kitSize,
      bundle: true,
      id: kitId,
      imgUrl: image
    });
  });
};

const transformItems = ({ items }) => {
  const { bundles, kits, other } =
    items
      .reduce((result, item) => {
        if (item.properties.bundle_id) {
          result.bundles.push(item);
        } else if (item.properties.kit_id) {
          result.kits.push(item);
        } else {
          result.other.push(item);
        }
        return result;
      },
      { other: [], kits: [], bundles: [] });

  const bundleItems = bundles.length ? buildBundleItems({ items: bundles }) : [];
  const kitItems = kits.length ? buildKitItems({ items: kits }) : [];

  return [...other, ...bundleItems, ...kitItems];
};

export default transformItems;
